import { Box, Divider, Typography } from '@mui/material';
import {
  SchedulingConfirmItems,
  SchedulingProps,
  SchedulingWarningsProps,
} from '../SchedulingInterface';
import { InfoBox } from '@/components/infoBox/InfoBox';
import { styles } from './styles';
import { useTranslation } from 'react-i18next';
import { ScheduleItems } from './ScheduleItems';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { AppointmentTypeDTO } from '@/data/DTOs/schedule/AppointmentTypeDTO';
import { useEffect, useState } from 'react';
import { useAppointmentTypeService } from '@/data/services/schedule/useLocationService';
import { AppError } from '@/utils/AppError';

export const SchedulingConfirm = ({
  schedule,
  internalObject,
  setCurrentStep,
  setShowWarning,
}: SchedulingProps & SchedulingWarningsProps) => {
  const { t } = useTranslation('schedule');
  const [appointmentsType, setAppointmentsType] = useState<
    AppointmentTypeDTO[]
  >([]);
  const allConfirmItems = ScheduleItems({ internalObject });
  // const scheduleAppointmentType = ScheduleAppointmentType.isOnline(
  //   schedule.appointmentTypeId
  // );
  const { getAppointmentTypeList } = useAppointmentTypeService();
  const selectedAppointmentType = appointmentsType.find(
    (type) => type.id === String(schedule.appointmentTypeId)
  );

  console.log('schedule', schedule);
  const fetchAppointmentType = async () => {
    getAppointmentTypeList()
      .then((items) => {
        setAppointmentsType(items);
      })
      .catch((error: AppError) => {
        setShowWarning(true);
        console.log(t(error.message));
      });
  };

  useEffect(() => {
    fetchAppointmentType();
  }, []);

  const infoCard = (information: SchedulingConfirmItems, index: number) => {
    const fromReschedule = schedule.id != '' && schedule.id != undefined;
    const disableEdit =
      (fromReschedule && index == 0) ||
      (fromReschedule && index == 1) ||
      (fromReschedule && index == 4);

    return (
      <Box key={index}>
        <InfoBox
          iconLeft={information.iconLeft}
          title={information.title}
          text={information.text}
          subText={information.subText}
          iconRight={
            <EditOutlinedIcon
              sx={disableEdit ? styles.disabled : styles.editIcon}
            />
          }
          rightIconDisable={disableEdit}
          onRightIconClick={() => {
            setShowWarning(false);
            setCurrentStep(index);
          }}
        />
        <Divider />
      </Box>
    );
  };

  // const valuesTypographies = (
  //   left: string,
  //   right: string,
  //   riskRight?: string
  // ) => {
  //   const totalAmount = riskRight != undefined;
  //   return (
  //     <Box sx={styles.valuesTypographies}>
  //       <Typography
  //         sx={[
  //           totalAmount ? styles.totalText : styles.valuesText,
  //           styles.title,
  //         ]}
  //       >
  //         {left}
  //       </Typography>
  //       <Box sx={styles.valuesTypographies}>
  //         {riskRight && (
  //           <Typography
  //             sx={[totalAmount && styles.lineInText, styles.valuesText]}
  //           >
  //             {riskRight}
  //           </Typography>
  //         )}
  //         <Typography sx={totalAmount ? styles.higherValue : styles.valuesText}>
  //           {right}
  //         </Typography>
  //       </Box>
  //     </Box>
  //   );
  // };

  const totalValue = () => {
    return (
      <Box sx={styles.textContainer}>
        {/* {valuesTypographies(
          t('screen_choose_confirm_schedule_appointment_price'),
          `U$ ${internalObject.price}`
        )}
        {valuesTypographies(
          t('screen_choose_confirm_schedule_discount_price'),
          '- U$ 100,00'
        )}
        {valuesTypographies(
          t('screen_choose_pay_total_value'),
          'U$100,00',
          'U$ 50,00'
        )} */}
        {totalValueMock()}
      </Box>
    );
  };

  const totalValueMock = () => {
    return (
      <Box sx={styles.footer}>
        <Box sx={styles.totalValueBox}>
          <Typography sx={styles.totalValueText}>
            {t('screen_choose_pay_total_value')}
          </Typography>
          <Typography>
            U$
            {selectedAppointmentType?.price.toFixed(2)}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.subtitle}>
        {t('screen_choose_before_confirm_appointment_subtitle')}
      </Typography>
      <Box sx={styles.listContainer}>
        {allConfirmItems.map((information, index) =>
          infoCard(information, index)
        )}
      </Box>
      {totalValue()}
    </Box>
  );
};
